<template>
  <section id="dashboard-analytics">
    <b-row class="match-height">
      <b-col
        lg="6"
        md="12"
      >
        <analytics-congratulation :data="userData" />
      </b-col>
      <!-- <b-col
        lg="3"
        sm="3"
      >
        <b-card
          text-variant="center"
          class="card"
        >
          <feather-icon icon="AlertCircleIcon" style="height: 50px; width: 50px; color: gold;"/>
          <br>
          <br>
          <b-card-text class="m-auto w-75">
            Pengguna Aplikasi Ujian Online <br>dihimbau agar membaca tata tertib dibawah ini
          </b-card-text>
          <br>
          <b-card-text class="m-auto w-75">
            <a @click="lihatFile(userData.tata_tertib)" href="#"><feather-icon icon="FileIcon" /> Tata Tertib Pelaksanaan Pengujian Skripsi</a> 
          </b-card-text>
        </b-card>
      </b-col> -->
      <!-- <b-col
        lg="3"
        sm="3"
      >
        <b-card
          text-variant="center"
          class="card"
        >
          <feather-icon icon="AlertCircleIcon" style="height: 50px; width: 50px; color: gold;"/>
          <br>
          <br>
          <b-card-text class="m-auto w-75">
            Pengguna Aplikasi Ujian Online <br>dihimbau agar membaca tata cara dibawah ini
          </b-card-text>
          <br>
          <b-card-text class="m-auto w-75">
            <a href="#" @click="lihatFile(userData.tata_cara)"><feather-icon icon="FileIcon" /> Tata Cara Sidang Skripsi</a> 
          </b-card-text>
        </b-card>
      </b-col> -->
    </b-row>

    <!-- <b-row class="match-height" v-if="$can('manage','all-content')">
      <b-col
        xl="12"
        md="12"
      >
        <ecommerce-statistics :data="statisticsItems" />
      </b-col>
       <b-col
          lg="4"
          md="4"
          cols="4"
        >
          <ecommerce-order-chart :data="pengajuanTiapStatus" />
        </b-col>
        <b-col
          lg="4"
          md="4"
          cols="4"
        >
          <ecommerce-order-chart2 :data="pengajuanTiapJenjang" />
        </b-col>
        <b-col
          lg="4"
          md="4"
          cols="4"
        >
          <hasil-sidang-berdasarkan-status :data="donutChart" />
        </b-col>
        <b-col
        xl="6"
        md="6"
      >
      <div>
        <b-card body-class="pb-50">
          <h6 class="mb-2 sticky-header">Total Membimbing</h6>
          <b-table :items="dosenBimbingan" :fields="fields" responsive="sm" class="table-scrollable">
            <template #cell(jumlah_bimbingan)="data">
              {{ data.item.jumlah_bimbingan }}
            </template>
          </b-table>
        </b-card>
      </div>
      </b-col>
      <b-col
        xl="6"
        md="6"
      >
      <div>
        <b-card body-class="pb-50">
          <h6 class="mb-2 sticky-header">Total Menguji</h6>
          <b-table :items="dosenPenguji" :fields="fields2" responsive="sm" class="table-scrollable">
            <template #cell(jumlah_bimbingan)="data">
              {{ data.item.jumlah_bimbingan }}
            </template>
          </b-table>
        </b-card>
      </div>
      </b-col>
    </b-row> -->
  </section>
</template>

<script>
import { BRow, BCol, BCard, BCardText, BTable } from 'bootstrap-vue'

import StatisticCardWithAreaChart from '@core/components/statistics-cards/StatisticCardWithAreaChart.vue'
import { kFormatter } from '@core/utils/filter'
import InvoiceList from '@/views/apps/invoice/invoice-list/InvoiceList.vue'
import AnalyticsCongratulation from './AnalyticsCongratulation.vue'
import AnalyticsAvgSessions from './AnalyticsAvgSessions.vue'
import AnalyticsSupportTracker from './AnalyticsSupportTracker.vue'
import AnalyticsTimeline from './AnalyticsTimeline.vue'
import AnalyticsSalesRadarChart from './AnalyticsSalesRadarChart.vue'
import AnalyticsAppDesign from './AnalyticsAppDesign.vue'
import EcommerceMedal from './EcommerceMedal.vue'
import EcommerceStatistics from './EcommerceStatistics.vue'
import EcommerceRevenueReport from './EcommerceRevenueReport.vue'
import EcommerceOrderChart from './EcommerceOrderChart.vue'
import EcommerceOrderChart2 from './EcommerceOrderChart2.vue'
import EcommerceProfitChart from './EcommerceProfitChart.vue'
import EcommerceEarningsChart from './EcommerceEarningsChart.vue'
import EcommerceCompanyTable from './EcommerceCompanyTable.vue'
import EcommerceMeetup from './EcommerceMeetup.vue'
import EcommerceBrowserStates from './EcommerceBrowserStates.vue'
import EcommerceGoalOverview from './EcommerceGoalOverview.vue'
import EcommerceTransactions from './EcommerceTransactions.vue'
import HasilSidangBerdasarkanStatus from './HasilSidangBerdasarkanStatus.vue'
import {
  getUserDetailDashboard,
  downloadFileDashboard,
} from '@/connection-api/master'
import { $themeColors } from '@themeConfig'
const chartColors = {
  column: {
    series1: '#826af9',
    series2: '#d2b0ff',
    bg: '#f8d3ff',
  },
  success: {
    shade_100: '#7eefc7',
    shade_200: '#06774f',
  },
  donut: {
    series1: '#ffe700',
    series2: '#00d4bd',
    series3: '#826bf8',
    series4: '#2b9bf4',
    series5: '#FFA1A1',
  },
  area: {
    series3: '#a4f8cd',
    series2: '#60f2ca',
    series1: '#2bdac7',
  },
}


export default {
  components: {
    BRow,
    BCol,
    AnalyticsCongratulation,
    AnalyticsAvgSessions,
    StatisticCardWithAreaChart,
    AnalyticsSupportTracker,
    AnalyticsTimeline,
    AnalyticsSalesRadarChart,
    AnalyticsAppDesign,
    InvoiceList,
    BCard,
    BCardText,
    EcommerceMedal,
    EcommerceStatistics,
    EcommerceRevenueReport,
    EcommerceOrderChart,
    EcommerceProfitChart,
    EcommerceEarningsChart,
    EcommerceCompanyTable,
    EcommerceMeetup,
    EcommerceBrowserStates,
    EcommerceGoalOverview,
    EcommerceTransactions,
    EcommerceOrderChart2,
    HasilSidangBerdasarkanStatus,
    BTable,
  },
  data() {
    return {
      fields: [
        { key: 'dosen_name', label: 'Nama Dosen' },
        { key: 'jumlah_bimbingan', label: 'Jumlah Bimbingan' },
      ],
      fields2: [
        { key: 'dosen_name', label: 'Nama Dosen' },
        { key: 'jumlah_bimbingan', label: 'Jumlah Menguji' },
      ],
      dosenBimbingan: [],
      dosenPenguji: [],
      data:{},
      userData: {},
      statisticsItems: [
        {
          icon: 'BoxIcon',
          color: 'light-primary',
          title: '0',
          subtitle: 'Total Pengajuan',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'UserIcon',
          color: 'light-info',
          title: '0',
          subtitle: 'Dalam Proses Persetujuan',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'Edit3Icon',
          color: 'light-info',
          title: '0',
          subtitle: 'Terjadwal',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'CheckIcon',
          color: 'light-success',
          title: '0',
          subtitle: 'Selesai',
          customClass: 'mb-2 mb-sm-0',
        },
      ],
      temp_series: [],
      pengajuanTiapStatus: {
         series: [
          {
            name: 'Jumlah',
            data: [0, 0, 0],
          },
        ],
        chartOptions: {
          chart: {
            type: 'bar',
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          grid: {
            show: true,
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '20%',
              colors: {
                backgroundBarRadius: 5,
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: true,
          },
          colors: [$themeColors.info],

          xaxis: {
            categories: ['Dalam Proses', 'Terjadwal', 'Selesai'],
            labels: {
              show: true,
            },
            axisBorder: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            show: true,
          },
          tooltip: {
            x: {
              show: true,
            },
          },
        },
      },
      pengajuanTiapJenjang: {
          series: [
            {
              name: 'Jumlah',
              data: [0, 0, 0],
            },
          ],
          chartOptions: {
            chart: {
              type: 'bar',
              stacked: false,
              toolbar: {
                show: false,
              },
            },
            grid: {
              show: true,
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '20%',
                colors: {
                  backgroundBarRadius: 5,
                },
              },
            },
            legend: {
              show: false,
            },
            dataLabels: {
              enabled: true,
            },
            colors: [$themeColors.success],

            xaxis: {
              categories: ['S1', 'S2', 'S3'],
              labels: {
                show: true,
              },
              axisBorder: {
                show: false,
              },
              axisTicks: {
                show: false,
              },
            },
            yaxis: {
              show: true,
            },
            tooltip: {
              x: {
                show: true,
              },
            },
          },
        },
      donutChart: {
        series: [0,0,0],
        chartOptions: {
          chart: {
            type: 'pie',
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
            position: 'bottom',
            fontSize: '14px',
            fontFamily: 'Montserrat',
          },
          colors: [
            chartColors.donut.series1,
            chartColors.donut.series5,
            chartColors.donut.series3,
            chartColors.donut.series2,
          ],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                  name: {
                    fontSize: '2rem',
                    fontFamily: 'Montserrat',
                  },
                  value: {
                    fontSize: '1rem',
                    fontFamily: 'Montserrat',
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  // total: {
                  //   show: true,
                  //   fontSize: '1.5rem',
                  //   label: 'Lulus Tanpa Revisi',
                  //   formatter() {
                  //     return '31%'
                  //   },
                  // },
                },
              },
            },
          },
          labels: ['Lulus Dengan Revisi', 'Lulus Tanpa Revisi', 'Tidak Lulus'],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: '1.5rem',
                        },
                        value: {
                          fontSize: '1rem',
                        },
                        total: {
                          fontSize: '1.5rem',
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      },
    }
  },
  created() {
    // data
    // this.$http.get('/analytics/data')
    //   .then(response => { this.data = response.data })

    // this.$http.get('/ecommerce/data')
    // .then(response => { 
    //   this.data = response.data 
    //   })
  },
  methods: {
    pieChart(seriesPie)
    {
       this.donutChart = {
        series: seriesPie,
        chartOptions: {
          chart: {
            type: 'pie',
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          legend: {
            show: true,
            position: 'bottom',
            fontSize: '14px',
            fontFamily: 'Montserrat',
          },
          colors: [
            chartColors.donut.series1,
            chartColors.donut.series5,
            chartColors.donut.series3,
            chartColors.donut.series2,
          ],
          dataLabels: {
            enabled: true,
            formatter(val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`
            },
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: false,
                  name: {
                    fontSize: '2rem',
                    fontFamily: 'Montserrat',
                  },
                  value: {
                    fontSize: '1rem',
                    fontFamily: 'Montserrat',
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  // total: {
                  //   show: true,
                  //   fontSize: '1.5rem',
                  //   label: 'Lulus Tanpa Revisi',
                  //   formatter() {
                  //     return '31%'
                  //   },
                  // },
                },
              },
            },
          },
          labels: ['Lulus Dengan Revisi', 'Lulus Tanpa Revisi', 'Tidak Lulus'],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380,
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320,
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: '1.5rem',
                        },
                        value: {
                          fontSize: '1rem',
                        },
                        total: {
                          fontSize: '1.5rem',
                        },
                      },
                    },
                  },
                },
                legend: {
                  show: true,
                },
              },
            },
          ],
        },
      }
    },
    kFormatter,
    async lihatFile(file) {
      try {
        if (typeof file === 'object') {
          // kode yang dijalankan jika file adalah object
          file = file.nama
        }
        const resp = await downloadFileDashboard(file);
        var type_file = file.substring(file.length - 4);
        if (type_file === ".pdf") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "application/pdf" })
          );
        }
        if (type_file === ".png" || type_file === ".PNG" || 
            type_file === ".jpg" || type_file === ".JPG" || 
            type_file === ".jpeg" || type_file === ".JPEG") {
          this.imageFile = URL.createObjectURL(
            new Blob([resp.data], { type: "image/" + type_file.slice(1) })
          );
        }
        window.open(this.imageFile);
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hasil Sidang',
            icon: 'EditIcon',
            variant: 'danger',
            text: 'File tidak ditemukan',
          },
          duration: 5000,
        })
      }
    },
  },
}
</script>
<style>
.table-scrollable {
  max-height: 400px; /* Adjust this height as needed */
  overflow-y: scroll;
  position: relative;
}

.sticky-header {
  position: sticky;
  top: 0;
  background: white;
  z-index: 1020; /* Ensure it is above other elements */
  padding-top: 10px;
}
</style>
